import React from 'react'

import styles from './SkipLink.scss'

const SkipLink = ({ skipToContentTag }) => (
  <div className={styles.skip} id={'skiptocontent'} data-test={'skip-button'}>
    <a tabIndex={1} className={styles.skipButton} href={skipToContentTag}>
      Skip to content
    </a>
  </div>
)

export default SkipLink
